import React from 'react'

import typographyStyles from './typography.module.css'

const DisplayTitle = (props) => (
  <h1 className={typographyStyles.displayTitle} {...props} />
)

const PageTitle = (props) => (
  <h2 className={typographyStyles.pageTitle} {...props} />
)

const SectionTitle = (props) => (
  <h3 className={typographyStyles.sectionTitle} {...props} />
)

const SubsectionTitle = (props) => (
  <h4 className={typographyStyles.subsectionTitle} {...props} />
)

const BodyTitle = (props) => (
  <p className={typographyStyles.bodyTitle} {...props} />
)

const BodyText = (props) => (
  <p className={typographyStyles.bodyText} {...props} />
)

const TestimonialsText = (props) => (
  <p className={typographyStyles.testimonialsText} {...props} />
)

const ArticleText = (props) => (
  <span className={typographyStyles.articleText} {...props} />
)

const BigLabel = (props) => (
  <span className={typographyStyles.bigLabel} {...props} />
)

const SmallLabel = (props) => (
  <span className={typographyStyles.smallLabel} {...props} />
)

const ButtonLabel = (props) => (
  <span className={typographyStyles.buttonLabel} {...props} />
)

const ExternalLinkLabel = (props) => (
  <span className={typographyStyles.externalLinkLabel} {...props} />
)

const TagLabel = (props) => (
  <span className={typographyStyles.tagLabel} {...props} />
)

const InlineLinkLabel = (props) => (
  <span className={typographyStyles.inlineLinkLabel} {...props} />
)

const PlaceholderText = (props) => (
  <span className={typographyStyles.placeholderText} {...props} />
)

export {DisplayTitle, PageTitle, SectionTitle, SubsectionTitle, 
  BodyTitle, BodyText, TestimonialsText, ArticleText, BigLabel, 
  SmallLabel, ButtonLabel, ExternalLinkLabel, TagLabel, InlineLinkLabel, 
  PlaceholderText  } 